// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xKa2G{display:flex;align-items:center;gap:8px;grid-column:span 2}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldWithTooltip": `xKa2G`
};
export default ___CSS_LOADER_EXPORT___;
